// src/components/DeletionDialog.jsx
import React from "react";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

const DeletionDialog = ({
  open,
  onClose,
  onConfirm,
  isDeleting = false,
  title = "Confirm Deletion",
  message = "Are you sure you want to delete this item? This action cannot be undone.",
  confirmText = "Delete",
  cancelText = "Cancel",
  tNamespace = "common",
}) => {
  const { t } = useTranslation(tNamespace);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-5 md:p-6 rounded-lg shadow-2xl w-[90%] sm:w-3/4 md:w-2/3 lg:w-1/3 max-w-md">
        {/* Title */}
        <h2 className="text-lg sm:text-xl md:text-2xl font-semibold mb-4 text-gray-800">
          {t(title) || title}
        </h2>

        {/* Message */}
        <p className="text-sm sm:text-base text-gray-600 mb-6 leading-relaxed">
          {t(message) || message}
        </p>

        {/* Buttons */}
        <div className="flex justify-end gap-3 sm:gap-4">
          <button
            onClick={onClose}
            disabled={isDeleting}
            className={`
              px-4 py-2 text-sm md:text-base font-medium rounded-md
              bg-gray-200 text-gray-700 hover:bg-gray-300
              transition-colors duration-200
              disabled:opacity-50 disabled:cursor-not-allowed
            `}
          >
            {t(cancelText) || cancelText}
          </button>

          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className={`
              px-4 py-2 text-sm md:text-base font-medium rounded-md
              bg-red-500 text-white hover:bg-red-600
              transition-colors duration-200 flex items-center gap-2
              disabled:opacity-50 disabled:cursor-not-allowed
            `}
          >
            {isDeleting && (
              <CircularProgress size={16} sx={{ color: "white" }} />
            )}
            {t(confirmText) || confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletionDialog;
